import Style from "../../style/eventfiltermiddle.module.scss";

const EventFilterMiddle = ({ itemList }: any) => {
  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
    };

    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  return (
    <div className={Style.container}>
      {itemList.length === 0 ? (
        <p>No events available for this date.</p>
      ) : (
        itemList.map((item: any) => {
          const startDateFormatted = formatDate(item.start_date);
          const endDateFormatted = formatDate(item.end_date);
          return (
            <div key={item.id} className={Style.card}>
              <h2>
                {startDateFormatted} - {endDateFormatted}
              </h2>
              <a
                href={`/event/title/${item.title
                  .toLowerCase()
                  .replaceAll(" ", "-")}`}
              >
                {item.title}
              </a>
              <h4>
                {item.venue.address},{" "}
                <a
                  href={`/event/city/${item.venue.city
                    .toLowerCase()
                    .replaceAll(" ", "-")}`}
                >
                  {item.venue.city}
                </a>
              </h4>
              <p>{item.description}</p>
              <ul>
                {item.tags.map((tag: string, index: number) => (
                  <li key={index}>
                    <a href={`/event/format/${tag}`}>{tag}</a>
                  </li>
                ))}
              </ul>
            </div>
          );
        })
      )}
    </div>
  );
};

export default EventFilterMiddle;
